export enum CompanyId {
  Håjt = 7,
  JRAB = 8,
  UTAB = 9,
  GJoSon = 12,
  VaGruppen = 13,
}
